const openNewWindow = (url) => {
  window.open(url, '_blank');
};

export default openNewWindow;
  